import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Uszkodzenie} from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {SlownikUszkodzen} from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {StrategiaPodsumowaniaUszkodzenia} from './strategia/strategia-podsumowania-uszkodzenia';

@Component({
  selector: 'app-uszkodzenie',
  templateUrl: './uszkodzenie.component.html'
})
export class UszkodzenieComponent {

  @Output()
  uszkodzenieWysokoscResize = new EventEmitter<number>()

  @Input()
  zbiorUszkodzenPrzedmiotuId!: number

  @Input()
  uszkodzenie!: Uszkodzenie<any>

  @Input()
  zbiorUszkodzenId!: string

  @Input()
  linkEdycji!: string[]

  @Output()
  usunUszkodzenieClick = new EventEmitter<{
    zbiorUszkodzenPrzedmiotowId: number,
    zbiorUszkodzenId: string,
    identyfikatorUszkodzenia: string
  }>()

  usunUszkodzenie(event: {
    zbiorUszkodzenPrzedmiotowId: number,
    zbiorUszkodzenId: string,
    identyfikatorUszkodzenia: string
  }): void {
    this.usunUszkodzenieClick.emit(event)
  }

  getStrategiaPodsumowaniaUszkodzenia(): StrategiaPodsumowaniaUszkodzenia {
    return new StrategiaPodsumowaniaUszkodzenia(
      this.getSlownikUszkodzen(this.uszkodzenie.nazwa),
      this.uszkodzenie);
  }

  private getSlownikUszkodzen(nazwaUszkodzenia: string): SlownikUszkodzen {
    return Object.values(SlownikUszkodzen).find(slownikUszkodzen => slownikUszkodzen.nazwa === nazwaUszkodzenia);
  }
}
